import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import { BasicForm } from './basic-form';
import { DonationForm } from './donation-form';
import { useHowToHelp } from '../../hooks/use-how-to-help';
import { STATUSES } from '../../hooks/use-async';

const SubmitButton = ({ loading }) => (
    <Button
        type="submit"
        className="btn btn-success text-uppercase px-4 py-3"
    >
        {loading ? (
            <React.Fragment>
                <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                Please wait ...
            </React.Fragment>
        ) : <span>Submit form</span>
        }
    </Button>
);

SubmitButton.propTypes = {
    loading: PropTypes.bool,
};

SubmitButton.defaultProps = {
    loading: false,
};

const Form = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [token, setToken] = React.useState();
    const fetchRecaptchaToken = async () => {
        try {
            const resp = await executeRecaptcha('how_to_help');
            if (resp) {
                setToken(resp);
            }
        } catch (exError) {
            console.error('Invalid recaptcha!', exError);
        }
    };

    React.useEffect(() => {
        fetchRecaptchaToken();
    }, []);

    const {
        register,
        execute,
        status,
        error,
        message,
        control,
        cities,
        countries,
        errors,
        trigger,
        handleSubmit,
    } = useHowToHelp();
    const isLoading = () => status === STATUSES.PENDING;
    const postData = async () => {
        const result = await trigger();
        if (!result) {
            return;
        }
        if (token) {
            execute();
        } else {
            console.error('Missing recaptcha validation!');
        }
    };
    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(postData)();
    };


    if (message) {
        return (
            <div className={`alert alert-${error ? 'danger' : 'success'}`} role="alert">
                {message}
            </div>
        );
    }
    return (
        <form className="form" action="#" method="post" onSubmit={onSubmit}>
            <BasicForm
                register={register}
                control={control}
                cities={cities}
                countries={countries}
                errors={errors}
            />
            <DonationForm
                register={register}
            />
            <SubmitButton
                loading={isLoading()}
            />
            <input
                ref={register}
                type="hidden"
                value={token}
                name="token"
            />
        </form>
    );
};


export const HowToHelp = ({ reCaptchaKey }) => (
    <GoogleReCaptchaProvider
        useRecaptchaNet
        reCaptchaKey={reCaptchaKey}
    >
        <Form />
    </GoogleReCaptchaProvider>
);

export class HowToHelpWrapper extends React.Component {
    render() {
        return (
            <HowToHelp reCaptchaKey={this.props.rcKey} />
        );
    }
}

